export default __webpack_public_path__ + "static/media/stock_medical_billing.ee65eac0.png";